import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// Admin-only app settings (backend: /admin/settings)
class SettingsService {

    getSettings() {
        return axiosInstance().get(path + "/admin/settings");
    }

    updateSettings(settings) {
        return axiosInstance().put(path + "/admin/settings", settings);
    }

    // AI Help: one tiny call with the saved Anthropic key and model -> { ok, message }
    testAi() {
        return axiosInstance().post(path + "/admin/settings/ai/test");
    }
}

export default new SettingsService()
